import { MessageMedia } from '@/shared/interfaces/MessageMedia'
import { ApiHandler } from '../ApiHandler'

export abstract class MediasApi {
  public static async get(
    chatId: number,
    filetype: 'photo' | 'video' | 'audio' | 'document',
    page: number,
  ): Promise<{
    page: number;
    page_count: number;
    medias: MessageMedia[];
  }> {
    return await ApiHandler.get(
      `chats/${chatId}/medias/${filetype}`, {page, chat_id: chatId, filetype},
    )
  }

  /** Сводка: сколько фото/видео/аудио/файлов (для скрытия пустых вкладок). */
  public static async summary(chatId: number): Promise<{ photo: number; video: number; audio: number; document: number }> {
    return await ApiHandler.get(`chats/${chatId}/media-summary`)
  }

  /** Ссылки из сообщений чата. */
  public static async links(chatId: number): Promise<{ links: LinkItem[] }> {
    return await ApiHandler.get(`chats/${chatId}/links`)
  }
}

export interface LinkItem {
  message_id: number
  url: string
  text: string
  author: string
  dt_departure: string | null
}
